import getConfig from "config";
import AccountIcon from "@enerex/unified-ui-react/icons/AccountIcon";
import AIIcon from "@enerex/unified-ui-react/icons/AIIcon";
import CommercialIcon from "@enerex/unified-ui-react/icons/CommercialIcon";
import ContractIcon from "@enerex/unified-ui-react/icons/ContractIcon";
import AggregationIcon from "@enerex/unified-ui-react/icons/AggregationIcon";
import DocumentsIcon from "@enerex/unified-ui-react/icons/DocumentsIcon";
import LicenseIcon from "@enerex/unified-ui-react/icons/LicenseIcon";
import MatrixIcon from "@enerex/unified-ui-react/icons/MatrixIcon";
import PricingIcon from "@enerex/unified-ui-react/icons/PricingIcon";
import ProductsIcon from "@enerex/unified-ui-react/icons/ProductsIcon";
import UsersIcon from "@enerex/unified-ui-react/icons/UsersIcon";
import UtilitiesIcon from "@enerex/unified-ui-react/icons/UtilitiesIcon";
import WarningIcon from "@enerex/unified-ui-react/icons/WarningIcon";

const config = getConfig();
const MENU_ITEMS = [
    //{
    //    key: 'dashboard',
    //    label: 'Dashboard',
    //    isTitle: false,
    //    icon: 'uil-dashboard',
    //    url: '/'
    //},
    // {
    //     key: 'license',
    //     label: 'Licenses Data',
    //     isTitle: false,
    //     icon: 'uil-atm-card',
    //     children: [
    //         { key: 'licenseFlow', label: 'Browse Data', url: '/licenses/browse', parentKey: 'license' }
    //         // { key: 'licensesRawData', label: 'Raw Data', url: '/licenses/rawData', parentKey: 'license' }
    //     ]
    // }
    // ,
    // {
    //     key: 'offers',
    //     label: 'Offers Data',
    //     isTitle: false,
    //     icon: 'uil-dollar-sign',
    //     children: [
    //         { key: 'offersFlow', label: 'Browse Data', url: '/offers/browse', parentKey: 'offers' },
    //         { key: 'offersRawData', label: 'Raw Data', url: '/offers/rawData', parentKey: 'offers' }
    //     ]
    // }
    // ,
    {
        key: "companyData",
        label: "PUC Licenses",
        isTitle: true,

        //children: [
        //    { key: 'companyData', label: 'Companies', url: '/companies', parentKey: 'companies' },
        //    // { key: 'companyData', label: 'Browse Data New', url: '/companies/companiesDataNew', parentKey: 'companies' },
        //]
    },

    {
        key: "dashboard",
        label: "Licenses",
        isTitle: false,
        icon: <LicenseIcon />,
        url: "/",
        moduleKey: "license",
        //children: [
        //    { key: 'companyData', label: 'Companies', url: '/companies', parentKey: 'companies' },
        //    // { key: 'companyData', label: 'Browse Data New', url: '/companies/companiesDataNew', parentKey: 'companies' },
        //]
    },
    {
        key: "companyData",
        label: "Companies",
        isTitle: false,
        icon: <CommercialIcon />,
        url: "/companies",
        moduleKey: "license",
        //children: [
        //    { key: 'companyData', label: 'Companies', url: '/companies', parentKey: 'companies' },
        //    // { key: 'companyData', label: 'Browse Data New', url: '/companies/companiesDataNew', parentKey: 'companies' },
        //]
    },
    {
        key: "pricingData",
        label: "Pricing Trends",
        isTitle: true,
        //children: [
        //    { key: 'companyData', label: 'Companies', url: '/companies', parentKey: 'companies' },
        //    // { key: 'companyData', label: 'Browse Data New', url: '/companies/companiesDataNew', parentKey: 'companies' },
        //]
    },
    //TODO: include in menu when it is available
    {
        key: "pricing",
        label: "Matrix",
        isTitle: false,
        icon: <MatrixIcon />,
        url: "/pricing/matrix",
        moduleKey: "pricing",
        // isHidden: !config.PricingMatrix.isVisible,
        // url: '/pricing'
    },
     {
        key: "ranking",
        label: "Ranking",
        isTitle: false,
        icon: <ProductsIcon />,
        url: "/pricing/ranking",
        moduleKey: "pricing",
        // isHidden: !config.PricingMatrix.isVisible,
        // url: '/pricing'
    },
    {
        key: "customPricing",
        label: "Custom",
        isTitle: false,
        icon: <PricingIcon />,
        url: "/pricing/custom",
        moduleKey: "pricing",
    },
    {
        key: "account",
        label: "Account Lookup",
        isTitle: true,
        //children: [
        //    { key: 'companyData', label: 'Companies', url: '/companies', parentKey: 'companies' },
        //    // { key: 'companyData', label: 'Browse Data New', url: '/companies/companiesDataNew', parentKey: 'companies' },
        //]
    },
    {
        key: "esi",
        label: "ESIID",
        isTitle: false,
        icon: <AccountIcon />,
        url: "/account/esiid",
        moduleKey: "esiid",
        // isHidden: !config.PricingMatrix.isVisible,
        // url: '/pricing'
    },
    {
        key: "ecl",
        label: "ECL",
        isTitle: false,
        icon: <AccountIcon />,
        url: "/account/ecl",
        moduleKey: "ecl",
        // isHidden: !config.PricingMatrix.isVisible,
        // url: '/pricing'
    },
    {
        key: "huRequest",
        label: "Historical Usage",
        isTitle: false,
        icon: <AccountIcon />,
        url: "/account/hu-request",
        moduleKey: "huRequest",
        requireSystemAdminAccess: true,
        isHidden:true
    },
    {
        key: "aiAssistants",
        label: "AI Assistants",
        isTitle: true,
        requireSystemAdminAccess: true,

    },
    {
        key: "contractAI",
        label: "Contract AI",
        isTitle: false,
        requireSystemAdminAccess: true,

        icon: <ContractIcon />,
        url: "/ai/contract",
        moduleKey: "contractAI",
    },
    {
        key: "billAI",
        label: "Bill AI",
        isTitle: false,
        requireSystemAdminAccess: true,

        icon: <DocumentsIcon />,
        url: "/ai/bill",
        moduleKey: "billAI",
    },
    {
        key: 'complaintsTitle',
        label: 'Complaints',
        isTitle: true,
        requireSystemAdminAccess: true
    },
    {
        key: 'complaintsOverview',
        label: 'Overview',
        isTitle: false,
        icon: <WarningIcon />,
        requireSystemAdminAccess: true,
        url: '/complaints/overview'
    },
    {
        key: 'complaintsPeers',
        label: 'Peers',
        isTitle: false,
        icon: <UsersIcon />,
        requireSystemAdminAccess: true,
        url: '/complaints/peers'
    },
    {
        key: 'complaintsIntelligence',
        label: 'Intelligence',
        isTitle: false,
        icon: <AIIcon />,
        requireSystemAdminAccess: true,
        url: '/complaints/intelligence'
    },
    // {
    //     key: 'dataManagementTitle',
    //     label: 'Data Management',
    //     isTitle: true,
    //     requireSystemAdminAccess: true,
    // },
    // {
    //     key: 'companyAlias',
    //     label: 'Company Alias',
    //     isTitle: false,
    //     icon: <AggregationIcon />,
    //     requireSystemAdminAccess: true,
    //     url: '/data-management/company-alias',
    // },
    // {
    //     key: 'utilities',
    //     label: 'Utilities',
    //     isTitle: false,
    //     icon: <UtilitiesIcon />,
    //     requireSystemAdminAccess: true,
    //     url: '/utilities',
    // },
    // {
    //     key: 'rateClasses',
    //     label: 'Rate Classes',
    //     isTitle: false,
    //     icon: 'uil uil-list-ul',
    //     requireSystemAdminAccess: true,
    //     url: '/data-management/rate-class',
    // },

    // {
    //     key: 'brand',
    //     label: 'Brand',
    //     isTitle: false,
    //     icon: <AggregationIcon />,
    //     requireSystemAdminAccess: true,
    //     url: '/data-management/brand',
    // },
    // {
    //     key: 'users',
    //     label: 'Users',
    //     isTitle: false,
    //     icon: 'uil-user',
    //     url: '/users',
    //     requireAdminAccess: true
    // }

    //{ key: 'apps', label: 'Apps', isTitle: true },
    //{ key: 'apps-calendar', label: 'Calendar', isTitle: false, icon: 'uil-calender', url: '/apps/calendar' },
    //{ key: 'apps-chat', label: 'Chat', isTitle: false, icon: 'uil-comments-alt', url: '/apps/chat' },
    //{
    //    key: 'apps-ecommerce',
    //    label: 'Ecommerce',
    //    isTitle: false,
    //    icon: 'uil-store',
    //    children: [
    //        {
    //            key: 'ecommerce-products',
    //            label: 'Products',
    //            url: '/apps/ecommerce/products',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        {
    //            key: 'ecommerce-details',
    //            label: 'Products Details',
    //            url: '/apps/ecommerce/details',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        { key: 'ecommerce-orders', label: 'Orders', url: '/apps/ecommerce/orders', parentKey: 'apps-ecommerce' },
    //        {
    //            key: 'ecommerce-order-details',
    //            label: 'Order Details',
    //            url: '/apps/ecommerce/order/details',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        {
    //            key: 'ecommerce-customers',
    //            label: 'Customers',
    //            url: '/apps/ecommerce/customers',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        {
    //            key: 'ecommerce-shopping-cart',
    //            label: 'Shopping Cart',
    //            url: '/apps/ecommerce/shopping-cart',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        {
    //            key: 'ecommerce-checkout',
    //            label: 'Checkout',
    //            url: '/apps/ecommerce/checkout',
    //            parentKey: 'apps-ecommerce',
    //        },
    //        { key: 'ecommerce-sellers', label: 'Sellers', url: '/apps/ecommerce/sellers', parentKey: 'apps-ecommerce' },
    //    ],
    //},
    //{
    //    key: 'apps-email',
    //    label: 'Email',
    //    isTitle: false,
    //    icon: 'uil-envelope',
    //    children: [
    //        { key: 'email-inbox', label: 'Inbox', url: '/apps/email/inbox', parentKey: 'apps-email' },
    //        { key: 'email-read-email', label: 'Read Email', url: '/apps/email/details', parentKey: 'apps-email' },
    //    ],
    //},
    //{
    //    key: 'apps-projects',
    //    label: 'Projects',
    //    isTitle: false,
    //    icon: 'uil-briefcase',
    //    children: [
    //        { key: 'project-list', label: 'List', url: '/apps/projects/list', parentKey: 'apps-projects' },
    //        { key: 'project-details', label: 'Details', url: '/apps/projects/:id/details', parentKey: 'apps-projects' },
    //        {
    //            key: 'project-gantt',
    //            label: 'Gantt',
    //            url: '/apps/projects/gantt',
    //            badge: { variant: 'light-lighten', text: 'New' },
    //            parentKey: 'apps-projects',
    //        },
    //        {
    //            key: 'project-create-project',
    //            label: 'Create Project',
    //            url: '/apps/projects/new',
    //            badge: { variant: 'success-lighten', text: 'New' },
    //            parentKey: 'apps-projects',
    //        },
    //    ],
    //},
    //{ key: 'apps-social', label: 'Social Feed', isTitle: false, icon: 'uil-rss', url: '/apps/social' },
    //{
    //    key: 'apps-tasks',
    //    label: 'Tasks',
    //    isTitle: false,
    //    icon: 'uil-clipboard-alt',
    //    children: [
    //        { key: 'task-list', label: 'List', url: '/apps/tasks/list', parentKey: 'apps-tasks' },
    //        { key: 'task-details', label: 'Details', url: '/apps/tasks/details', parentKey: 'apps-tasks' },
    //        { key: 'task-kanban', label: 'Kanban Board', url: '/apps/tasks/kanban', parentKey: 'apps-tasks' },
    //    ],
    //},
    //{ key: 'apps-file-manager', label: 'File Manager', isTitle: false, icon: 'uil-folder-plus', url: '/apps/file' },

    //{ key: 'custom', label: 'Custom', isTitle: true },
    //{
    //    key: 'pages',
    //    label: 'Pages',
    //    isTitle: false,
    //    icon: 'uil-copy-alt',
    //    children: [
    //        { key: 'page-profile', label: 'Profile', url: '/pages/profile', parentKey: 'pages' },
    //        { key: 'page-profile2', label: 'Profile 2', url: '/pages/profile2', parentKey: 'pages' },
    //        { key: 'page-invoice', label: 'Invoice', url: '/pages/invoice', parentKey: 'pages' },
    //        { key: 'page-faq', label: 'FAQ', url: '/pages/faq', parentKey: 'pages' },
    //        { key: 'page-pricing', label: 'Pricing', url: '/pages/pricing', parentKey: 'pages' },
    //        {
    //            key: 'page-maintenance',
    //            label: 'Maintenance',
    //            url: '/maintenance',
    //            target: '_blank',
    //            parentKey: 'pages',
    //        },
    //        { key: 'page-error-404', label: 'Error - 404', url: '/error-404', parentKey: 'pages' },
    //        { key: 'page-error-404-alt', label: 'Error - 404-alt', url: '/pages/error-404-alt', parentKey: 'pages' },
    //        { key: 'page-error-500', label: 'Error - 500', url: '/error-500', parentKey: 'pages' },
    //        { key: 'page-starter', label: 'Starter Page', url: '/pages/starter', parentKey: 'pages' },
    //        { key: 'page-preloader', label: 'With Preloader', url: '/pages/preloader', parentKey: 'pages' },
    //        { key: 'page-timeline', label: 'Timeline', url: '/pages/timeline', parentKey: 'pages' },
    //    ],
    //},
    //{
    //    key: 'landing',
    //    label: 'Landing',
    //    isTitle: false,
    //    icon: 'uil-globe',
    //    url: '/landing',
    //    target: '_blank',
    //    badge: { variant: 'light-lighten', text: 'New' },
    //},

    //{ key: 'components', label: 'Components', isTitle: true },
    //{
    //    key: 'base-ui',
    //    label: 'Base UI',
    //    isTitle: false,
    //    icon: 'uil-box',
    //    children: [
    //        { key: 'base-ui-accordions', label: 'Accordions', url: '/ui/accordions', parentKey: 'base-ui' },
    //        { key: 'base-ui-alerts', label: 'Alerts', url: '/ui/alerts', parentKey: 'base-ui' },
    //        { key: 'base-ui-avatars', label: 'Avatars', url: '/ui/avatars', parentKey: 'base-ui' },
    //        { key: 'base-ui-badges', label: 'Badges', url: '/ui/badges', parentKey: 'base-ui' },
    //        { key: 'base-ui-breadcrumb', label: 'Breadcrumb', url: '/ui/breadcrumb', parentKey: 'base-ui' },
    //        { key: 'base-ui-buttons', label: 'Buttons', url: '/ui/buttons', parentKey: 'base-ui' },
    //        { key: 'base-ui-cards', label: 'Cards', url: '/ui/cards', parentKey: 'base-ui' },
    //        { key: 'base-ui-carousel', label: 'Carousel', url: '/ui/carousel', parentKey: 'base-ui' },
    //        { key: 'base-ui-dropdown', label: 'Dropdowns', url: '/ui/dropdowns', parentKey: 'base-ui' },
    //        { key: 'base-ui-embedvideo', label: 'Embed Video', url: '/ui/embedvideo', parentKey: 'base-ui' },
    //        { key: 'base-ui-grid', label: 'Grid', url: '/ui/grid', parentKey: 'base-ui' },
    //        { key: 'base-ui-listgroups', label: 'List Groups', url: '/ui/listgroups', parentKey: 'base-ui' },
    //        { key: 'base-ui-modals', label: 'Modals', url: '/ui/modals', parentKey: 'base-ui' },
    //        { key: 'base-ui-notifications', label: 'Notifications', url: '/ui/notifications', parentKey: 'base-ui' },
    //        { key: 'base-ui-offcanvas', label: 'Offcanvas', url: '/ui/offcanvas', parentKey: 'base-ui' },
    //        { key: 'base-ui-paginations', label: 'Paginations', url: '/ui/paginations', parentKey: 'base-ui' },
    //        { key: 'base-ui-popovers', label: 'Popovers', url: '/ui/popovers', parentKey: 'base-ui' },
    //        { key: 'base-ui-progress', label: 'Progress', url: '/ui/progress', parentKey: 'base-ui' },
    //        { key: 'base-ui-ribbons', label: 'Ribbons', url: '/ui/ribbons', parentKey: 'base-ui' },
    //        { key: 'base-ui-spinners', label: 'Spinners', url: '/ui/spinners', parentKey: 'base-ui' },
    //        { key: 'base-ui-tabs', label: 'Tabs', url: '/ui/tabs', parentKey: 'base-ui' },
    //        { key: 'base-ui-tooltips', label: 'Tooltips', url: '/ui/tooltips', parentKey: 'base-ui' },
    //        { key: 'base-ui-typography', label: 'Typography', url: '/ui/typography', parentKey: 'base-ui' },
    //    ],
    //},
    //{
    //    key: 'extended-ui',
    //    label: 'Extended UI',
    //    isTitle: false,
    //    icon: 'uil-package',
    //    children: [
    //        { key: 'extended-ui-dragdrop', label: 'Drag and Drop', url: '/ui/dragdrop', parentKey: 'extended-ui' },
    //        {
    //            key: 'extended-ui-rangesliders',
    //            label: 'Range Sliders',
    //            url: '/ui/rangesliders',
    //            parentKey: 'extended-ui',
    //        },
    //        { key: 'extended-ui-ratings', label: 'Ratings', url: '/ui/ratings', parentKey: 'extended-ui' },
    //    ],
    //},
    //{ key: 'widgets', label: 'Widgets', isTitle: false, icon: 'uil-layer-group', url: '/ui/widgets' },
    //{
    //    key: 'icons',
    //    label: 'Icons',
    //    isTitle: false,
    //    icon: 'uil-streering',
    //    children: [
    //        { key: 'icon-dripicons', label: 'Dripicons', url: '/ui/icons/dripicons', parentKey: 'icons' },
    //        { key: 'icon-mdiicons', label: 'Material Design', url: '/ui/icons/mdi', parentKey: 'icons' },
    //        { key: 'icon-unicons', label: 'Unicons', url: '/ui/icons/unicons', parentKey: 'icons' },
    //    ],
    //},
    //{
    //    key: 'forms',
    //    label: 'Forms',
    //    isTitle: false,
    //    icon: 'uil-document-layout-center',
    //    children: [
    //        { key: 'form-basic', label: 'Basic Elements', url: '/ui/forms/basic', parentKey: 'forms' },
    //        { key: 'form-advanced', label: 'Form Advanced', url: '/ui/forms/advanced', parentKey: 'forms' },
    //        { key: 'form-validation', label: 'Validation', url: '/ui/forms/validation', parentKey: 'forms' },
    //        { key: 'form-wizard', label: 'Wizard', url: '/ui/forms/wizard', parentKey: 'forms' },
    //        { key: 'form-upload', label: 'File Upload', url: '/ui/forms/upload', parentKey: 'forms' },
    //        { key: 'form-editors', label: 'Editors', url: '/ui/forms/editors   ', parentKey: 'forms' },
    //    ],
    //},
    //{
    //    key: 'charts',
    //    label: 'Charts',
    //    isTitle: false,
    //    icon: 'uil-chart',
    //    children: [
    //        { key: 'chart-apex', label: 'Apex Charts', url: '/ui/charts/apex', parentKey: 'charts' },
    //        { key: 'chart-brite', label: 'Brite Charts', url: '/ui/charts/brite', parentKey: 'charts' },
    //        { key: 'chart-chartjs', label: 'Chartjs', url: '/ui/charts/chartjs', parentKey: 'charts' },
    //    ],
    //},
    //{
    //    key: 'tables',
    //    label: 'Tables',
    //    isTitle: false,
    //    icon: 'uil-table',
    //    children: [
    //        { key: 'table-basic', label: 'Basic Tables', url: '/ui/tables/basic', parentKey: 'tables' },
    //        { key: 'table-advanced', label: 'Advanced Tables', url: '/ui/tables/advanced', parentKey: 'tables' },
    //    ],
    //},
    //{
    //    key: 'maps',
    //    label: 'Maps',
    //    isTitle: false,
    //    icon: 'uil-location-point',
    //    children: [
    //        { key: 'maps-googlemaps', label: 'Google Maps', url: '/ui/googlemaps', parentKey: 'maps' },
    //        { key: 'maps-vectormaps', label: 'Vector Maps', url: '/ui/vectormaps', parentKey: 'maps' },
    //    ],
    //},
    //{
    //    key: 'menu-levels',
    //    label: 'Menu Levels',
    //    isTitle: false,
    //    icon: 'uil-folder-plus',
    //    children: [
    //        {
    //            key: 'menu-levels-1-1',
    //            label: 'Level 1.1',
    //            url: '/',
    //            parentKey: 'menu-levels',
    //            children: [
    //                {
    //                    key: 'menu-levels-2-1',
    //                    label: 'Level 2.1',
    //                    url: '/',
    //                    parentKey: 'menu-levels-1-1',
    //                    children: [
    //                        { key: 'menu-levels-3-1', label: 'Level 3.1', url: '/', parentKey: 'menu-levels-2-1' },
    //                        { key: 'menu-levels-3-2', label: 'Level 3.2', url: '/', parentKey: 'menu-levels-2-1' },
    //                    ],
    //                },
    //                { key: 'menu-levels-2-2', label: 'Level 2.2', url: '/', parentKey: 'menu-levels-1-1' },
    //            ],
    //        },
    //        { key: 'menu-levels-1-2', label: 'Level 1.2', url: '/', parentKey: 'menu-levels' },
    //    ],
    //},
];

export default MENU_ITEMS;
